module.exports = __webpack_public_path__ + "static/media/iota.3ef0a89f.svg";